// base styles
import breakpoints from 'assets/theme/base/breakpoints';

const {
  values: { xs }
} = breakpoints;

const XS = `@media (min-width: ${xs}px)`;

export default {
  styleOverrides: {
    root: {
      [XS]: {
        marginTop: 0
      }
    }
  }
};
